import { render, staticRenderFns } from "./DatenschutzErklärung.vue?vue&type=template&id=61151367&"
import script from "./DatenschutzErklärung.vue?vue&type=script&lang=js&"
export * from "./DatenschutzErklärung.vue?vue&type=script&lang=js&"
import style0 from "./DatenschutzErklärung.vue?vue&type=style&index=0&id=61151367&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports